import Aipreset from "./aipreset";

export default Aipreset;
